<div class="container-fluid">
  <page-header-search
    [isSearchInput]="true"
    [pageTitleValue]="pageTitle"
    [placeholderValue]="placeholder"
    (onHeaderInputKeyup)="onSearchInputKeyup($event)"
    (onHeaderSearchSubmit)="onSearchAppointment($event)"
  ></page-header-search>

  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-12 status-filter-btns">
          <h5 class="filter">Filter By</h5>
          <div class="filter-btn-container">
            <button
              class="btn btn-filter"
              (click)="onBtnSearchAppointment('0')"
            >
              All
            </button>
            <button
              class="btn btn-filter"
              (click)="onBtnSearchAppointment('1')"
            >
              Pending
            </button>
            <button
              class="btn btn-filter"
              (click)="onBtnSearchAppointment('2')"
            >
              Finished
            </button>
            <button
              class="btn btn-filter"
              (click)="onBtnSearchAppointment('3')"
            >
              Cancelled
            </button>
            <button
              class="btn btn-filter"
              (click)="onBtnSearchAppointment('4')"
            >
              Not Completed
            </button>
            <button
              class="btn btn-filter"
              (click)="onBtnSearchAppointment('8')"
            >
              Active
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!filteredLiveAppointmentsArray.length">
    <div class="col-12 text-center py-5">Hmm, There are no on-going appointments 🥳</div>
  </div>

  <div *ngIf="filteredLiveAppointmentsArray.length" class="card">
    <div class="card-body">
      <div class="table-title">
        <div class="table-title-actions">
          <h3 class="title mb-0">{{ selectedTab }} - Live Appointments</h3>
          <button class="btn btn-neutral" (click)="ExportTOExcel()">
            <span class="btn-inner--icon">
              <i class="ni ni-cloud-download-95"> </i>
            </span>
            <span class="btn-inner--text"> Download as Excel </span>
          </button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th
                class="sort"
                data-sort="patientName"
                scope="col"
                sortable="patientName"
                (sort)="onSort($event)"
              >
                Patient Name
              </th>
              <th
                class="sort"
                data-sort="doctorName"
                scope="col"
                sortable="doctorName"
                (sort)="onSort($event)"
              >
                Doctor Name
              </th>
              <th
                class="sort"
                data-sort="appointmentTime"
                scope="col"
                sortable="appointmentTime"
                (sort)="onSort($event)"
              >
                Appointment Time
              </th>
              <th
                class="sort"
                data-sort="statusId"
                scope="col"
                sortable="statusId"
                (sort)="onSort($event)"
              >
                Status
              </th>
              <th
                class="sort"
                data-sort="displayName"
                scope="col"
                sortable="displayName"
                (sort)="onSort($event)"
              >
                Display Name
              </th>
              <th
                class="sort"
                data-sort="isHavePrescription"
                scope="col"
                sortable="isHavePrescription"
                (sort)="onSort($event)"
              >
                Has prescription
              </th>
              <th scope="col">Appointment Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="pointer"
              *ngFor="let item of filteredLiveAppointmentsArray"
              (click)="onAppointmentDetails($event, item)"
            >
              <td>
                <span *ngIf="!item.isAnonymous">{{ item.patientName }}</span>
              </td>
              <td>
                <span>{{ item.doctorName }}</span>
              </td>
              <td>
                <span>{{ item.appointmentTime?.split("T")[0] }}</span>
                <br />
                <span>{{ item.appointmentTime?.split("T")[1] }}</span>
              </td>
              <td>
                <span>{{ getStatusName(item.statusId) }}</span>
              </td>
              <td>
                <span *ngIf="item.isAnonymous">{{ item.displayName }}</span>
              </td>
              <td>
                <span>{{ item.isHavePrescription ? "🟢 YES" : "🔴 NO" }}</span>
              </td>
              <td>
                <button
                  class="btn btn-icon mr-2"
                  [ngClass]="{
                    'btn-warning': item.refund,
                    'btn-outline-warning': !item.refund
                  }"
                  [disabled]="item.refund"
                  type="button"
                  placement="top"
                  tooltip="Refund"
                  (click)="onRefundHandler($event, item)"
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-money-coins"> </i>
                  </span>
                </button>
                <!-- <button
                  class="btn btn-icon mr-2"
                  [ngClass]="{
                    'btn-success': item.reactive,
                    'btn-outline-success': !item.reactive
                  }"
                  [disabled]="item.reactive"
                  type="button"
                  placement="top"
                  tooltip="Reactive"
                  (click)="onReactiveHandler($event, item)"
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-check-bold"> </i>
                  </span>
                </button>
                <button
                  class="btn btn-icon"
                  [ngClass]="{
                    'btn-danger': item.hasProblem,
                    'btn-outline-danger': !item.hasProblem
                  }"
                  type="button"
                  placement="top"
                  tooltip="Add Problem"
                  (click)="onAddProblem($event, item)"
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-button-power"> </i>
                  </span>
                </button> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
